// extracted by mini-css-extract-plugin
export default {"default-badge":"V3fEK9ay"};